import type { FleetVehicle } from '@/lib/api/fleet-api'
import { useVehicleCameraLatest } from '@/hooks/use-vehicle-gps-query'
import { addressText, speedText } from '@/lib/fleet-format'
import { m } from '@/lib/paraglide/messages'

interface Props {
    vehicle: FleetVehicle
    active: boolean
    departed: boolean
    onSelect: (id: string) => void
}

// Một xe đang chạy trong danh sách cột phải. Thumbnail snapshot (không live để
// nhẹ), biển số, tốc độ, địa chỉ. Chạm để ghim spotlight.
export function StationFleetRow({ vehicle, active, departed, onSelect }: Props) {
    const hasCamera = Boolean(vehicle.gps?.has_camera)
    const latest = useVehicleCameraLatest(vehicle.vehicle_id, hasCamera)
    const thumb = latest.data?.photos?.[0]?.image_url

    return (
        <button
            type="button"
            data-testid="station-fleet-row"
            data-active={active ? 'true' : 'false'}
            aria-current={active ? 'true' : undefined}
            onClick={() => onSelect(vehicle.vehicle_id)}
            className={`station-fleet-row ${active ? 'is-active' : ''} ${
                departed ? 'is-departed' : ''
            }`}
        >
            <span className="station-fleet-thumb">
                {thumb ? (
                    <img src={thumb} alt={vehicle.plate_number} />
                ) : (
                    <span className="station-fleet-thumb-empty">
                        {m.fleet_no_camera()}
                    </span>
                )}
            </span>
            <span className="station-fleet-body">
                <span className="station-fleet-top">
                    <span className="station-fleet-plate">
                        {vehicle.plate_number}
                    </span>
                    <span className="station-fleet-speed">
                        {speedText(vehicle)}
                    </span>
                </span>
                <span className="station-fleet-addr">
                    {addressText(vehicle)}
                </span>
            </span>
        </button>
    )
}
